import { auth } from '../services/auth.js'

async function getBearer() {
  const details = await auth.getIdToken()
  if (!details || (details.idToken === null || details.idToken === '' || details.idToken === undefined)) {
    console.error('failed to grab id token')
    return
  }
  return details.idToken
}

async function getHeaders(contentType, needAuth=true) {
  // default to json if we don't declare a value
  if (contentType === undefined) contentType = 'application/json'

  let headers = {}
  if (needAuth){
    let bearer = await getBearer()
    if (bearer) headers.Authorization = `Bearer ${bearer}`
  }

  // if we passed in contentType = null then just omit the content type
  if (contentType != null) headers['Content-Type'] = `${contentType}`
  return headers
}

export let get = async function get(url, needAuth=true) {
  let headers = {}
  if (needAuth){
    headers = {
      Authorization: `Bearer ${await getBearer()}`
    }
  }

  return await fetch(url, {
    headers
  })
    .then((response) => response.json())
    .then((data) => data)
}

// Like get/post, but also returns the HTTP status so callers can tell
// "not found" apart from a server error without matching on message text.
export let getWithStatus = async function getWithStatus(url, needAuth=true) {
  let response = await fetch(url, { headers: await getHeaders(null, needAuth) })
  return { status: response.status, data: await response.json().catch(() => ({})) }
}

export let postWithStatus = async function postWithStatus(url, data, needAuth=true) {
  let response = await fetch(url, {
    method: 'POST',
    headers: await getHeaders('application/json', needAuth),
    body: data,
  })
  return { status: response.status, data: await response.json().catch(() => ({})) }
}

export let post = async function post(url, data, contentType, returnData, needAuth=true) {
  // default returnData to true
  // most endpoints should return data except for favorites
  if (returnData === undefined) returnData = true

  let headers = await getHeaders(contentType, needAuth)

  return await fetch(url, {
    method: 'POST',
    headers,
    body: data,
  }).then((response) => {
    if (returnData === true) return response.status !== 204 ? response.json() : true;
    return response.ok
  })
}

export let put = async function put(url, data, contentType, returnData) {
  // default returnData to true
  // most endpoints should return data except for favorites
  if (returnData === undefined) returnData = true

  return await fetch(url, {
    method: 'PUT',
    headers: await getHeaders(contentType),
    body: data,
  }).then((response) => {
    if (returnData === true) return response.status !== 204 ? response.json() : true;
    return response.ok
  })
}

export let del = async function del(url, data, contentType, returnData) {
  // default returnData to true
  // most endpoints should return data except for favorites
  if (returnData === undefined) returnData = true
  return await fetch(url, {
    method: 'DELETE',
    headers: await getHeaders(contentType),
    body: data,
  }).then((response) => {
    if (returnData === true) return response.status !== 204 ? response.json() : true;
    return response.ok
  })
}
